<template>
    <div class="form-group col-12">
        <label>Form</label>

        <form-selector :value="value" @input="$emit('input', $event)" />
    </div>
</template>

<script>
import FormSelector from '@/components/forms/Selector';

export default {
    components: {
        FormSelector
    },

    props: {
        value: {
            type: String,
            required: false,
            default: null
        }
    }
};
</script>
